module.exports = __webpack_public_path__ + "img/system-county-dyz.3a5dd65e.png";